export const ExperimentsConsts = {
  MyBookingsCssPBPIndication: 'specs.bookings.MyBookingsCssPBPIndication',
  MembersAreaLazyLoad: 'specs.bookings.members-area-lazy-load',
  MyBookingsShowFormSubmission: 'specs.bookings.MyBookingsShowFormSubmission',
  WixFormsMigration: 'specs.bookings.WixFormsMigration',
};
